<template>
    <b-modal size="md" button-size="sm" :title="prefix + title" @hidden="cancelar" @close="cancelar" v-model="showModal"
        hide-footer>
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <strong>{{ produto.descricaoProduto }}</strong>
            </div>
        </b-card>
        <b-card>
            <div>
                <span v-if="mostrar[0]"><strong>Consumo Total: </strong><span>{{ this.consumoTotal }} <br />
                    </span></span>

                <span v-if="mostrar[1]"><strong>N meses do C. M. M.: </strong>{{ this.numeroMesesCCM }} <br /></span>

                <span v-if="mostrar[2]"><strong>C. M. M.: </strong><span>{{ this.consumoMedioMensal }}</span>
                    <br /></span>

                <span v-if="mostrar[3]"><strong>Estoque Atual: </strong> <span>{{ this.estoqueAtual
                }}</span><br /></span>

                <span v-if="mostrar[4]"><strong>Estoque Residual: </strong><span>{{ this.estoqueResidual
                }}</span><br /></span>

                <span v-if="mostrar[5]"><strong>Duração estoque atual(meses) : </strong>
                    {{ this.duracaoEstoqueAtual }}<br /></span>
                <span v-if="mostrar[6]"><strong>Fator de segurança(%): </strong>
                    <span>{{ this.estoqueSeguranca }}</span><br /></span>
                <span v-if="mostrar[7]"><strong>Estoque Máximo: </strong><span>{{ this.estoqueMaximo }}
                    </span><br /></span>

                <span v-if="mostrar[9]"><strong>Prazo de Aquisição(meses): </strong><span>{{ this.prazoAquisicao
                }}</span> <br /></span>

                <span v-if="mostrar[8]"><strong>Ponto de Ressuprimento(Estoque de Segurança): </strong><span>{{
                    this.pontoRessuprimento
                        }}</span><br /></span>


                <span v-if="mostrar[10]"><strong>Intervalo de Aquisição(meses): </strong><span>{{
                    this.intervaloAquisicao }}</span><br /></span>
                <span v-if="mostrar[11]"><strong>Quantidade a ser adquirida: </strong><span>{{
                    this.quantidadeSerAquirida }}</span></span>

                <br />

            </div>

            <template #footer>
                <div class="d-flex w-100 justify-content-center">
                    <b-button id="cancelar" variant="danger" size="sm" pill class="ml-2" @click="cancelar">
                        <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                        <div class="btn-size-alinhamento">
                            <b-icon icon="x-circle" scale="1.2" />
                        </div>
                    </b-button>
                </div>
            </template>
        </b-card>
    </b-modal>
</template>
<script>
import ResourceService from "@/core/api/ResourceService"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"

export default {
    props: {
        produto: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            default: " > Ponto de Ressuprimento",
        },
        prefix: {
            type: String,
            default: "Itens do Almoxarifado ",
        },
    },

    mixins: [FormResourceMixin, ListResourceMixin],

    async beforeMount() {
        this.$service = new ResourceService("api/produto")

        var { data } = await new ResourceService("/api/configuracoes-sistema").get('279');
        if (data.valorPropriedade == null || data.valorPropriedade == "") {
            this.mostrar = [true, true, true, true, true, true, true, true, true, true, true, true]
        }
        else {
            this.mostrar = data.valorPropriedade
                .split(';')
                .filter(v => v !== '')
                .map(v => v === '1');
        }


    },

    mounted() {
        this.load()
    },

    data() {
        return {
            mostrar: [false, false, false, false, false, false, false, false, false, false, false, false],

            showModal: true,
            descricaoProduto: this.produto.descricaoProduto,
            consumoTotal: 0,
            estoqueResidual: 0,
            quantidadeSerAquirida: 0,
            numeroMesesCCM: 0,
            consumoMedioMensal: 0,
            estoqueMaximo: 0,
            estoqueAtual: 0,
            duracaoEstoqueAtual: 0,
            estoqueSeguranca: 0,
            prazoAquisicao: 0,
            pontoRessuprimento: 0,
            intervaloAquisicao: 0,
        }
    },

    methods: {
        async load() {
            await this.$service
                .get(`ponto-ressuprimento/${this.produto.idAlmoxarifado}/${this.produto.idProduto}`)
                .then(response => {
                    this.consumoTotal = response.data.consumoTotal
                    this.numeroMesesCCM = response.data.numeroMesesCCM
                    this.consumoMedioMensal = response.data.consumoMedioMensal
                    this.estoqueAtual = response.data.estoqueAtual
                    this.duracaoEstoqueAtual = response.data.duracaoEstoqueAtual
                    this.estoqueSeguranca = response.data.estoqueSeguranca
                    this.prazoAquisicao = response.data.prazoAquisicao
                    this.intervaloAquisicao = response.data.intervaloAquisicao;
                    this.pontoRessuprimento = response.data.pontoRessuprimento;
                    this.estoqueMaximo = response.data.estoqueMaximo;
                    this.estoqueResidual = response.data.estoqueResidual;
                    this.quantidadeSerAquirida = response.data.quantidadeSerAquirida;
                })
        },

        cancelar() {
            this.showModal = false
            this.$emit("close")
        },
    },
}
</script>
